(function ( $) {

    $(document).on('ready', function () {

        // putting in setTimeout() to give more time for loading of page DOM elements and ensure that ScrollMagic effects will be applied more accurate
        setTimeout(function () {
            var isTabletDevice = $('#to-check-if-tablet').filter(':visible').length > 0;
            var isMobileDevice = $('#to-check-if-mobile').filter(':visible').length > 0;

            var animatedController = new ScrollMagic.Controller();

            var isLastImageOnPage;

            var sceneDuration = false;
            if ( isTabletDevice ) sceneDuration = '75%';
            if ( isMobileDevice ) sceneDuration = '85%';

            var $animatedImages = $('.animated-image').not('.disable-animation');

            $animatedImages.each(function (index, value) {
                var $this = $(this);
                var $allAnimatedParts = $this.find('[class*="animate__"]');
                var isPlayedOnce = $this.hasClass('play-once');
                var isRowIconGrid = $this.hasClass('row-igrid-image');
                isLastImageOnPage = ((index === $animatedImages.length - 1) && (index !== 0));

                if ( isLastImageOnPage ) sceneDuration = 0;

                // for all cases except Icon Grid block on responsive
                if ( !((isTabletDevice || isMobileDevice) || $this.hasClass('disable-animation')) ){

                    $allAnimatedParts.each(function () {

                        var $thisAnimated = $(this);

                        $thisAnimated.attr('data-animated-part', '');

                        var animationClassToToggle = $thisAnimated.attr('class'); // getting animation-class that was set by designer for some of svg <g> element

                        $thisAnimated.removeClass(animationClassToToggle); // removing found designer-set-by class (will toggle it with ScrollMagic to trigger animation)

                        var scene = new ScrollMagic.Scene({
                            triggerElement: $this.get(0), // trigger element will be parent svg - to make all child's animation started at one time
                            duration: (sceneDuration !== false) ? sceneDuration : '90%',
                            triggerHook: isRowIconGrid ? 0.8 : 0.5,
                            offset: -$this.outerHeight() / 2,
                            reverse: !isPlayedOnce // to play once (on page-load) or every time element appears in viewport
                        })
                            // .addIndicators()
                            .addTo(animatedController);

                        scene.on('enter', function () {
                            // adding animation class to trigger animation for particular child svg element and displaying whole svg image (by removing img-hidden class)
                            $thisAnimated.addClass(animationClassToToggle);
                        });

                        if ( !isPlayedOnce ) { // this code is needed only when animation is set to be played every time element appears in viewport
                            scene.on('leave', function () {
                                // removing animation class to be able to trigger animation again and hiding whole svg image (by adding img-hidden class)
                                $thisAnimated.removeClass(animationClassToToggle);;
                            });
                        }
                    });


                }
                $this.removeClass('img-hidden');

            });
        }, 180);

    });

})( jQuery );